/* Carousels for the Tasting Flight + Vessel Set sections. Runs once; initialises every [data-tfx-car]. */
(function(){
  if (window.__tfxCar) return; window.__tfxCar = true;
  function init(car){
    if (car.dataset.ready) return; car.dataset.ready = '1';
    var track = car.querySelector('.tfx-track'), prev = car.querySelector('.tfx-prev'), next = car.querySelector('.tfx-next'), dots = car.querySelector('.tfx-dots');
    if (!track) return;
    function step(){ var c = track.children[0]; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : track.clientWidth; }
    function pages(){ return Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / step()) + 1); }
    function build(){
      if (!dots) return; dots.innerHTML = '';
      var n = pages(); if (n < 2) return;
      for (var i = 0; i < n; i++) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to slide ' + (i + 1)); (function(i){ b.addEventListener('click', function(){ track.scrollLeft = i * step(); }); })(i); dots.appendChild(b); }
      sync();
    }
    function sync(){
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.hidden = track.scrollLeft <= 2;
      if (next) next.hidden = track.scrollLeft >= max - 2;
      if (dots) { var i = Math.round(track.scrollLeft / step()); [].forEach.call(dots.children, function(d, k){ d.setAttribute('aria-current', k === i ? 'true' : 'false'); }); }
    }
    if (prev) prev.addEventListener('click', function(){ track.scrollLeft -= step(); });
    if (next) next.addEventListener('click', function(){ track.scrollLeft += step(); });
    track.addEventListener('scroll', function(){ requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', build);
    build();
  }
  function all(){ document.querySelectorAll('[data-tfx-car]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
